import PetIcon from '@/components/Icons/PetIcon';
import VideoCameraIcon from '@/components/Icons/VideoCameraIcon';
import type { PetPolicy } from '@/domain/pet-policies';
import type { Property } from '@/domain/properties';
import type { FC } from 'react';

const SHOW_PET_POLICY = false;

interface Props {
  property: Property;
  petPolicy?: PetPolicy;
}

const PropertyAdditionalDetailsCard: FC<Props> = ({ property, petPolicy }) => {
  if ((!petPolicy || !SHOW_PET_POLICY) && !property.virtualTourUrl) {
    return null;
  }
  return (
    <div className="bg-white p-8 rounded-none border border-gray-200">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Additional Details</h2>
      <div className="space-y-6">
        {petPolicy && SHOW_PET_POLICY ? (
          <div>
            <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
              <PetIcon />
              Pet Policy
            </h3>
            <p className="text-gray-700 ml-7">{petPolicy?.description ?? petPolicy.name}</p>
          </div>
        ) : null}

        {property.virtualTourUrl && (
          <div>
            <h3 className="font-semibold text-gray-900 mb-2 flex items-center">
              <VideoCameraIcon />
              Virtual Tour
            </h3>
            <a
              href={property.virtualTourUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-7 text-primary-600 hover:text-primary-700 underline"
            >
              View 360° Virtual Tour
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertyAdditionalDetailsCard;
